export default "__VITE_ASSET__9miNcFCC__"